import { ApplicationView } from "@mixitone/mvc";
// import SessionController from "controllers/SessionController";

export const HomeMenu = ApplicationView(() => {
  // const controller = SessionController.use();

  return (
    <div className="flex w-full justify-end pl-2 pr-3">
      <div className="flex items-center gap-3 self-end">
        {/* this would be modal link */}
        {/* {!controller.signedIn && (
          <Link href={routeHelpers.freeSession({})} className="gap-1 self-end">
            <span>Start for free</span>
            <StartIcon />
          </Link>
        )} */}
      </div>
    </div>
  );
});
